var _rect, _ellipse, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path27;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 148,
    viewBox: "0 0 165 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 59.0193,
    width: 129.251,
    height: 73.402,
    rx: 10,
    fill: "#F7F8FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 142,
    rx: 42,
    ry: 6,
    fill: "#EAEFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2445 65.4019C11.2458 65.4019 6.38287 70.6342 6.38287 77.0887V114.351C6.38287 120.806 11.2458 126.038 17.2445 126.038H112.007C118.006 126.038 122.869 120.806 122.869 114.351V77.0887C122.869 70.6342 118.006 65.4019 112.007 65.4019H94.2965C93.2967 65.4019 92.4862 66.2739 92.4862 67.3497C92.4862 68.4254 93.2967 69.2975 94.2965 69.2975H112.007C116.006 69.2975 119.248 72.7857 119.248 77.0887V114.351C119.248 118.654 116.006 122.143 112.007 122.143H17.2445C13.2454 122.143 10.0034 118.654 10.0034 114.351V77.0887C10.0034 72.7857 13.2454 69.2975 17.2445 69.2975H34.955C35.9548 69.2975 36.7653 68.4254 36.7653 67.3497C36.7653 66.2739 35.9548 65.4019 34.955 65.4019H17.2445Z",
    fill: "#CBD8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 0.5,
    width: 57.3573,
    height: 39.0889,
    rx: 2.5,
    fill: "white",
    stroke: "#EAEFFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.065,
    y: 1.02051,
    width: 16.5212,
    height: 3.64445,
    fill: "#2E62E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5872,
    y: 1.89502,
    width: 39.4378,
    height: 2.76978,
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 6.26831,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 10.0586,
    width: 55.8258,
    height: 1.74934,
    fill: "#2E62E6",
    fillOpacity: 0.56
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 13.8486,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 21.4294,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7254,
    y: 38.3394,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 37.7254 38.3394)",
    fill: "#E5E5E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7072,
    y: 38.3396,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 63.7072 38.3396)",
    fill: "#E5E5E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3171,
    y: 37.4648,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 49.3171 37.4648)",
    fill: "#E5E5E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 25.2197,
    width: 55.8258,
    height: 1.74934,
    fill: "#2E62E6",
    fillOpacity: 0.22
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 29.0098,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 32.8,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 36.5901,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1975,
    y: 17.6389,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.918 27.8894L128.332 34.7951H137.042L136.213 24.2334L127.918 27.8894Z",
    fill: "#F5D5C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.542 18.0214C120.737 26.5171 126.532 28.5622 129.876 28.4498C134.366 27.7464 130.369 28.7839 138.053 23.4665C145.737 18.149 132.689 5.3831 125.542 18.0214Z",
    fill: "#F5D5C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.817 28.0803C130.94 27.9219 133.02 26.8034 133.555 26.089C133.914 26.2007 134.401 26.643 133.48 27.5191C132.328 28.6142 125.83 28.3033 128.817 28.0803Z",
    fill: "#D0B5A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.918 29.311L122.526 30.3266L127.296 40.8883L136.835 40.4821L142.642 32.1546L136.835 29.311C132.688 36.7855 129.162 32.4254 127.918 29.311Z",
    fill: "#97B1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.669 32.7643C116.803 31.9518 123.839 30.2593 126.466 29.5145L121.697 40.2793C117.881 41.5792 110.153 40.1439 106.766 39.2638C102.784 38.6138 98.8855 31.2748 97.4339 27.6865C99.5906 27.3616 101.236 25.3846 101.789 24.4368C106.434 31.9112 108.978 33.1028 109.669 32.7643Z",
    fill: "#97B1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.812 67.6986C137.996 73.2232 125.015 70.0005 119.001 67.6986L119.623 56.5276L119.001 42.1068V31.7482C119.001 30.4483 123.978 30.1233 126.466 30.1233C126.632 42.6349 136.766 36.4197 141.812 31.7482C148.448 35.4854 148.448 36.9613 147.618 37.2321C146.789 44.1379 144.508 49.4187 143.471 53.0747L141.812 67.6986Z",
    fill: "#97B1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.878 39.8135L118.911 40.9829L106.931 39.9401L118.878 39.8135Z",
    fill: "#3063E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.741 39.8386L120.013 40.758L119.596 52.9411L118.741 39.8386Z",
    fill: "#3063E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.433 54.2311C141.77 53.9061 141.604 45.9713 141.604 42.0445C142.433 38.3073 144.369 36.4252 145.751 36.3574C152.595 34.5295 151.143 55.7154 151.558 59.1058C145.337 63.6367 134.415 62.4909 130.821 60.5275V56.0591C140.774 57.2778 143.263 54.6373 142.433 54.2311Z",
    fill: "#97B1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.301 54.6171C142.808 56.0795 138.011 56.1743 135.799 56.0389C142.435 55.8764 143.541 54.4817 143.264 53.8047C143.402 50.5549 143.679 44.5022 143.679 46.2896C143.679 48.077 144.094 52.586 144.301 54.6171Z",
    fill: "#3063E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.418 22.5068C138.906 20.2992 136.296 20.3514 134.805 20.6535C136.588 19.2224 134.609 17.736 133.397 17.1717C130.333 16.4174 129.457 14.9091 131.865 11.6522C133.792 9.04666 137.031 10.7059 138.41 11.8612C145.44 16.8484 141.333 21.6193 138.401 23.3813C138.275 23.4696 136.315 25.1294 135.797 25.0459C135.28 24.9625 137.189 22.817 137.418 22.5068Z",
    fill: "#453F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.343 11.6357C128.668 14.7034 130.951 15.9091 132.177 16.1284C133.504 14.8236 136.173 12.0469 136.232 11.3795C136.305 10.5452 130.187 7.80108 129.343 11.6357Z",
    fill: "#453F3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 34.5919L133.309 33.2433C133.936 32.2093 135.805 30.9845 136.346 30.2763C136.78 29.7091 136.627 28.7017 136.42 27.6861C137.577 27.4164 139.383 29.1974 139.528 30.2763C139.643 31.1394 136.491 33.513 134.9 34.5919Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.916 29.311V28.7017H126.672C126.506 28.7017 125.983 29.5818 126.052 29.9203C126.052 32.1952 129.437 34.6373 130.819 35.4498L132.066 33.3732C130.905 33.2107 128.4 30.5296 127.916 29.311Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.235 57.591C131.235 57.591 129.538 57.5299 129.102 57.1103C128.667 56.6906 127.011 55.7833 126.689 55.6964C126.367 55.6095 123.724 54.0854 123.675 54.8854C123.642 55.4377 125.071 55.7746 125.177 55.9658C125.296 56.1781 125.517 56.5415 125.257 56.6338C124.996 56.7263 123.529 56.4524 123.054 56.5145C122.578 56.5769 121.022 56.6396 120.858 56.8412C120.692 57.0431 120.746 57.4552 122.067 57.3035C123.359 57.155 124.204 57.483 124.204 57.483C124.204 57.483 122.787 57.8069 122.344 57.8515C121.846 57.9024 120.488 58.2025 120.379 58.42C120.264 58.6526 120.628 58.8597 120.628 58.8597C120.628 58.8597 120.082 59.3115 120.5 59.5082C120.919 59.7049 122.465 59.5737 122.753 59.6014C123.04 59.6285 124.553 59.7388 124.571 59.791C124.588 59.842 124.715 60.1263 124.502 60.145C124.289 60.163 121.856 60.5214 121.778 60.6355C121.699 60.749 121.626 61.0903 122.114 61.1049C122.601 61.1191 124.804 60.8562 125.066 60.8934C125.327 60.9293 126.779 60.9902 128.352 60.634C129.925 60.2782 130.725 60.3536 130.725 60.3536L131.235 57.591",
    fill: "#F5D5C3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.651 56.1216H130.406V61.6055H131.443L131.651 56.1216Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.903 135.457C120.903 135.457 118.742 136.912 117.583 137.389C116.425 137.865 111.795 138.765 111.361 139.167C111.226 139.292 110.315 140.159 110.722 140.473C110.858 140.578 111.534 140.885 112.89 140.993C115.916 141.233 119.646 141.283 120.127 140.993C120.608 140.702 121.424 140.274 121.424 140.274C121.424 140.274 121.457 141.128 122.147 141.185C122.838 141.243 125.685 140.598 125.685 140.598C125.685 140.598 126.578 136.231 125.247 134.624C123.914 133.017 120.903 135.457 120.903 135.457",
    fill: "#453F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.606 134.749L120.441 136.146C120.441 136.146 123.179 136.721 125.533 135.019L125.476 133.756L120.606 134.749",
    fill: "#97B1F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.15 135.863C139.15 135.863 136.988 137.318 135.83 137.794C134.671 138.271 130.041 139.171 129.608 139.573C129.472 139.698 128.561 140.565 128.969 140.878C129.105 140.983 129.78 141.29 131.137 141.398C134.163 141.639 137.893 141.689 138.374 141.399C138.855 141.108 139.671 140.68 139.671 140.68C139.671 140.68 139.704 141.534 140.393 141.591C141.085 141.649 143.932 141.004 143.932 141.004C143.932 141.004 144.825 136.637 143.493 135.03C142.16 133.422 139.15 135.863 139.15 135.863",
    fill: "#453F3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.852 135.155L138.688 136.552C138.688 136.552 141.426 137.127 143.78 135.425L143.722 134.161L138.852 135.155",
    fill: "#97B1F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.018 66.0739C135.589 67.9019 125.635 67.3603 119.414 65.2615L116.926 96.9466L119.207 135.131H126.257L125.013 101.415L130.405 79.6823L136.833 135.131H145.128C144.299 114.82 143.124 106.019 142.018 96.9466V66.0739Z",
    fill: "#C4C4C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9512 20.4364L96.4554 22.6218C95.9214 22.337 95.0068 21.9024 94.8482 22.1704C94.624 22.5521 96.1604 23.5871 96.5455 24.1207C96.897 24.6089 97.4068 25.387 97.854 25.8007L99.7152 27.2796L101.379 26.6846C101.379 26.6846 99.1801 21.4704 98.8234 20.6869C98.2455 19.4106 97.3882 19.492 97.0889 19.5565C96.5473 19.6717 94.9512 20.4364 94.9512 20.4364Z",
    fill: "#F5D5C3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8137 21.7659C96.0703 24.1338 94.5448 21.8755 94 20.4504L96.9965 19.1348C97.9954 19.0252 99.5572 19.3979 97.8137 21.7659Z",
    fill: "#F5D5C3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.643 20.7276C98.0911 20.9116 97.9531 23.4104 97.9531 24.6368L100.023 23.487C99.8694 22.9505 99.5628 21.7394 99.5628 21.1875C99.5628 20.4977 99.3328 20.4977 98.643 20.7276Z",
    fill: "#F5D5C3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.641 25.878L101.555 24.1653L96.7987 27.0587L97.7038 28.486L102.641 25.878Z",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7227,
    y: 8.72974,
    width: 57.3573,
    height: 39.0889,
    rx: 2.5,
    fill: "white",
    stroke: "#EAEFFC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2878,
    y: 9.25024,
    width: 16.5212,
    height: 3.64445,
    fill: "#2E62E6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8099,
    y: 10.1248,
    width: 39.4378,
    height: 2.76978,
    fill: "#E5E5E5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 14.4983,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 18.2886,
    width: 55.8258,
    height: 1.74934,
    fill: "#2E62E6",
    fillOpacity: 0.56
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 22.0786,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 29.6592,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9482,
    y: 46.5693,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 48.9482 46.5693)",
    fill: "#E5E5E5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9299,
    y: 46.5693,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 74.9299 46.5693)",
    fill: "#E5E5E5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5399,
    y: 45.6946,
    width: 30.3218,
    height: 1.59883,
    transform: "rotate(-90 60.5399 45.6946)",
    fill: "#E5E5E5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 33.4495,
    width: 55.8258,
    height: 1.74934,
    fill: "#2E62E6",
    fillOpacity: 0.22
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 37.2393,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 41.0298,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 44.8198,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4202,
    y: 25.8689,
    width: 55.8258,
    height: 1.74934,
    fill: "#E5E5E5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1328 82.735V40.7922C70.1328 39.8716 69.3931 39.1252 68.4807 39.1252H60.7708C59.8584 39.1252 59.1187 39.8716 59.1187 40.7922V82.735H52.7775C49.8337 82.735 48.3595 86.326 50.441 88.4263L62.2893 100.381C63.5797 101.683 65.6718 101.683 66.9621 100.381L78.8104 88.4263C80.8919 86.3261 79.4177 82.735 76.4739 82.735H70.1328V82.735Z",
    fill: "#97B1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIllustration);
export default __webpack_public_path__ + "static/media/import-illustration.6aa4c6a44909f53c7d967cbb4334c55d.svg";
export { ForwardRef as ReactComponent };